/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalAuthStart } from './PortalAuthStart';
import {
    PortalAuthStartFromJSON,
    PortalAuthStartFromJSONTyped,
    PortalAuthStartToJSON,
    PortalAuthStartToJSONTyped,
} from './PortalAuthStart';

/**
 * 
 * @export
 * @interface PortalAuthStartResponse
 */
export interface PortalAuthStartResponse {
    /**
     * 
     */
    data: PortalAuthStart;
}

/**
 * Check if a given object implements the PortalAuthStartResponse interface.
 */
export function instanceOfPortalAuthStartResponse(value: object): value is PortalAuthStartResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function PortalAuthStartResponseFromJSON(json: any): PortalAuthStartResponse {
    return PortalAuthStartResponseFromJSONTyped(json, false);
}

export function PortalAuthStartResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalAuthStartResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PortalAuthStartFromJSON(json['data']),
    };
}

export function PortalAuthStartResponseToJSON(json: any): PortalAuthStartResponse {
    return PortalAuthStartResponseToJSONTyped(json, false);
}

export function PortalAuthStartResponseToJSONTyped(value?: PortalAuthStartResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PortalAuthStartToJSON(value['data']),
    };
}

